export const selectSourcesData = state => state.sources.data

export const selectSourcesLoadingState = state => state.sources.loading
